export default __webpack_public_path__ + "static/media/Reimbursement_4.72b6bbff.png";